import { NAV_ITEMS, type NavItem } from '../../constants/navItems';
import { reportCatalog } from '../../reporting/reportCatalog';

// Routes outside the sidebar that belong under one of its pages.
const ALIASES: ReadonlyArray<[prefix: string, item: NavItem]> = [
  ['/intake', NAV_ITEMS.intakeManager],
  ['/reporting', NAV_ITEMS.reports],
];

const ROUTES: ReadonlyArray<[prefix: string, item: NavItem]> = [
  ...Object.values(NAV_ITEMS).map((item): [string, NavItem] => [
    item.path,
    item,
  ]),
  ...ALIASES,
];

const isUnder = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

/** The sidebar page a route sits under, as the first crumb of its trail. */
export const routeCrumb = (pathname: string): NavItem | null =>
  ROUTES.find(([prefix]) => isUnder(pathname, prefix))?.[1] ?? null;

/**
 * A report's name for the crumb after Reports, from the catalog the Reports
 * page lists its cards from, so the two always read the same.
 */
export const reportCrumb = (pathname: string): string | null =>
  reportCatalog.find(
    report =>
      isUnder(pathname, report.modernPath) ||
      (!!report.legacyPath && isUnder(pathname, report.legacyPath))
  )?.name ?? null;
